export const allItemUnavailableModalDataLocator = {
    all_items_unavailable_modal_title: 'all_items_unavailable_modal_title',
    all_items_unavailable_modal_ok_btn: 'all_items_unavailable_modal_ok_btn'
};
